import React from 'react';
import NotificationCard from './NotificationCard';
import Pagination from './Pagination';
import { Bell } from 'lucide-react';

const NotificationList = ({ 
  notifications, 
  loading, 
  onView, 
  onEdit, 
  onDelete, 
  onSend,
  pagination,
  onPageChange
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF6B00]"></div>
      </div>
    );
  }

  if (!notifications || notifications.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
        <Bell className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Aucune notification trouvée
        </h3>
        <p className="text-gray-500">
          Aucune notification ne correspond à vos critères de recherche.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {notifications.map((notification) => (
            <NotificationCard
              key={notification.id}
              notification={notification}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
              onSend={onSend}
            />
          ))}
        </div>
      </div>
      
      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          totalItems={pagination.totalItems}
          itemsPerPage={pagination.itemsPerPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default NotificationList;
